export const content = `
<svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.3333 0V15L28.3333 10L33.3333 15V0H40V40H10V0H23.3333ZM0 0H6.66667V40H0V0Z"
    fill="white" />
</svg>`